<script lang="ts">
    import { i18n, sprache } from "../store"
    import { getContent } from "../api"
    import { apiBaseURL, baseURL } from "../config"
    import Fehler404 from "./Fehler404.svelte"
    import Rows from "./Rows.svelte"
    import Breadcrumbs from "./Breadcrumbs.svelte"
    import MediaFile from "./MediaFile.svelte"
    import { previewEntryMap } from "../preview"

    export let pfad: string
    export let preview = false
    let seite: Content
    let lade: boolean = true

    let showedTag: string = ""

    $: if ($previewEntryMap["content"]) {
        lade = false
        seite = $previewEntryMap["content"]
        $previewEntryMap["content"] = null
    }

    async function ladeSeite(pfad: string) {
        seite = await getContent(pfad)
        scrollTo(0, 0)
    }

    $: if (seite && (seite.path.includes("/aktuelles") || seite.path.includes("/pressemeldung"))) {
        if (seite.tags_) {
            for (let tag of seite.tags_) {
                let tagName = tag.name.de
                if (tag.type == "projectSection") {
                    showedTag = tagName
                }
            }
        }
    }

    $: if (!preview) {
        ladeSeite(pfad)
    }
</script>

<!-- svelte-ignore missing-declaration -->
<svelte:head>
    {#key seite}
        <!-- Title -->
        {#if seite?.title}
            <title>{seite.title}</title>
        {:else if seite?.meta?.title}
            <title>{seite.meta.title}</title>
        {:else}
            <title>VDE 8</title>
        {/if}

        <!-- Description -->
        {#if seite?.meta?.description}
            <meta name="description" content="{seite.meta.description}" />
        {/if}

        <!-- Keywords -->
        {#if seite?.meta?.keywords}
            <meta name="keywords" content="{seite.meta.keywords}" />
        {/if}

        {#if seite?.public === false}
            <meta name="robots" content="noindex" />
        {/if}

        {#if seite?.path && seite.path != pfad}
            <link rel="canonical" href="{seite.path != '/' ? baseURL + seite.path : '/'}" />
        {/if}
    {/key}
</svelte:head>

{#if seite?.heroImage?.src || seite?.mlheroImage}
    <div class="hero">
        <div class="hero-bg">
            {#if seite?.heroImage?.src}
                <img
                    src="{!seite.heroImage?.src?.startsWith('data:')
                        ? apiBaseURL + 'content/' + seite.id + '/' + seite.heroImage?.src + '?filter=xl'
                        : seite.heroImage?.src}"
                    alt=""
                />
            {:else}
                <img
                    src="{!seite.mlheroImage_?.file?.src?.startsWith('data:')
                        ? apiBaseURL +
                          'media/' +
                          seite.mlheroImage_?._id +
                          '/' +
                          seite.mlheroImage_?.file?.src +
                          '?filter=xl'
                        : seite.mlheroImage_?.file?.src}"
                    alt=""
                />
            {/if}
        </div>
        <div class="wrapper">
            <div class="hero-title">
                <h1>{seite.title}</h1>
                {#if seite.subtitle}<h2>{seite.subtitle}</h2>{/if}
            </div>
        </div>
    </div>
{/if}

<Breadcrumbs />

{#key seite}
    {#if seite?.rows?.length}
        <div class="site-content">
            {#if showedTag}
                <div class="wrapper showtag">
                    <div class="datum">
                        <span>{new Date(seite.date).getDate()}.</span>
                        <span
                            >{new Date(seite.date).toLocaleString($sprache == "de" ? "de-DE" : "en-US", {
                                month: "long",
                            })}</span
                        > <span>{new Date(seite.date).getFullYear()}</span>
                    </div>
                    <div class="tag">
                        {showedTag}
                    </div>
                </div>
            {/if}
            <Rows rows="{seite.rows}" contentId="{seite.id}" />
        </div>
    {/if}

    {#if seite?.downloads?.length}
        <section class="mediathek-result border-top">
            <div class="wrapper">
                <h3>Downloads</h3>
                <div class="grid mediathek">
                    {#each seite.downloads as m}
                        {#if m.download_}<MediaFile file="{m.download_}" />{/if}
                    {/each}
                </div>
            </div>
        </section>
    {/if}

    {#if seite?.medialibrary === true}
        <section class="wrapper mediathek">
            <h3>Mediathek</h3>
            <div class="grid mediathek">
                <div class="grid-item">
                    <a href="{$i18n('/de/infothek/mediathek')}"
                        ><img src="assets/icons/ic-db-alle-01.svg" alt="{$i18n('Alle')}" />
                        {$i18n("Alle")}</a
                    >
                </div>
                <div class="grid-item">
                    <a href="{$i18n('/de/infothek/mediathek')}?filter=photo"
                        ><img src="assets/icons/ic-db-camera-01.svg" alt="{$i18n('Fotos')}" />
                        {$i18n("Fotos")}</a
                    >
                </div>
                <div class="grid-item">
                    <a href="{$i18n('/de/infothek/mediathek')}?filter=video"
                        ><img src="assets/icons/ic-db-il_pulse_movie.svg" alt="{$i18n('Videos')}" />
                        {$i18n("Videos")}</a
                    >
                </div>
                <div class="grid-item">
                    <a href="{$i18n('/de/infothek/mediathek')}?filter=document"
                        ><img src="assets/icons/ic-db-dokumente-01.svg" alt="{$i18n('Dokumente')}" />
                        {$i18n("Dokumente")}</a
                    >
                </div>
                <div class="grid-item">
                    <a href="{$i18n('/de/infothek/mediathek')}?filter=map"
                        ><img src="assets/icons/ic-db-il_pulse_itinerary.svg" alt="{$i18n('Karten')}" />
                        {$i18n("Karten")}</a
                    >
                </div>
            </div>
        </section>
    {/if}
{/key}

{#if !seite}
    <Fehler404 />
{/if}
